import { useQuery } from "@tanstack/react-query";
import { marketDataService } from "@/services/marketDataService";

export function useMarketDataProviders() {
  return useQuery({
    queryKey: ["market-data", "providers"],
    queryFn: marketDataService.getProviderStatus,
  });
}
